import * as Yup from 'yup';

import { ContentType } from '@candu-ai/content/types';
import {
  LogicOptions,
  ModalTimeFrames,
  SelectorLocation,
  URLOptions,
} from '@candu-ai/placement/types';

export const inlineValidationSchema = Yup.object().shape({
  selector: Yup.string().min(2, 'Must have at least 2 characters').required(),
  contentId: Yup.string(),
  slug: Yup.string(),
  location: Yup.string()
    .oneOf(Object.values(SelectorLocation), `A valid location is required`)
    .required('A location is required'),
  urlsLogicOperator: Yup.string()
    .oneOf(Object.values(LogicOptions), `A matching option must be set`)
    .required('A matching option must be set'),
  urls: Yup.array().of(
    Yup.object().shape({
      not: Yup.boolean(),
      operation: Yup.object()
        .shape({
          operand: Yup.string().required('A value for each rule is required'),
          type: Yup.string().oneOf(Object.values(URLOptions)),
        })
        .required(),
    }),
  ),
  denyURLs: Yup.array().of(Yup.string()),
});

export const hotspotValidationSchema = Yup.object().shape({
  contentId: Yup.string(),
  slug: Yup.string(),
  urlsLogicOperator: Yup.string()
    .oneOf(Object.values(LogicOptions), `A matching option must be set`)
    .required('A matching option must be set'),
  urls: Yup.array().of(
    Yup.object().shape({
      not: Yup.boolean(),
      operation: Yup.object()
        .shape({
          operand: Yup.string().required('A value for each rule is required'),
          type: Yup.string().oneOf(Object.values(URLOptions)),
        })
        .required(),
    }),
  ),
});

export const modalValidationSchema = Yup.object().shape({
  contentId: Yup.string(),
  slug: Yup.string(),
  showTimeframe: Yup.string()
    .oneOf(Object.values(ModalTimeFrames), `A matching option must be set`)
    .required('A matching option must be set'),
  urlsLogicOperator: Yup.string()
    .oneOf(Object.values(LogicOptions), `A matching option must be set`)
    .required('A matching option must be set'),
  urls: Yup.array().of(
    Yup.object().shape({
      not: Yup.boolean(),
      operation: Yup.object()
        .shape({
          operand: Yup.string().required('A value for each rule is required'),
          type: Yup.string().oneOf(Object.values(URLOptions)),
        })
        .required(),
    }),
  ),
  denyURLs: Yup.array().of(Yup.string()),
});

export const validationSchemas = {
  [ContentType.Inline]: inlineValidationSchema,
  [ContentType.Modal]: modalValidationSchema,
  [ContentType.HotspotGroup]: hotspotValidationSchema,
  [ContentType.Tour]: hotspotValidationSchema,
  [ContentType.Banner]: hotspotValidationSchema,
};
